import React, {Component} from 'react';
import {DeliveryStates, VinAllocation} from "./types/DeliveryTypes";
import {withRouter} from "../../hoc/withRouter";
import PageHeader from "../../component/header/PageHeader";
import FooterSection from "../../component/pageSection/FooterSection";
import {Breadcrumb, Card, Col, Empty, Row, Select, Spin, Typography, Tag, Space, Button} from "antd";
import {trimitraCatalogServices} from "../../services/trimitraCatalog/trimitraCatalogServices";
import {appDefaultArea} from "../../config/appDataConfig/appConfig";
import Cookies from "universal-cookie";
import {appName, appCompanyName} from "../../config/appDataConfig/appConfig";
import { useParams, useNavigate } from 'react-router-dom';
import FormDelivery from '../../component/delivery/FormDelivery';

const { Title, Text } = Typography;

interface ColorGroup {
    colorKey: string;
    vins: VinAllocation[];
}

// Wrapper component to get URL parameters
const DeliveryWrapper = (props: any) => {
    const { modelCode } = useParams();
    const navigate = useNavigate();
    return <Delivery {...props} modelCode={modelCode} navigate={navigate} />;
};

class Delivery extends Component<any, DeliveryStates> {
    private cookies = new Cookies();
    private readonly initState!: DeliveryStates;

    constructor(props: any) {
        super(props);

        if (!this.cookies.get('_amc-a')) {
            this.cookies.set('_amc-a', appDefaultArea);
        }

        this.initState = {
            isDesktop: false,
            fetching: true,
            modelSelected: props.modelCode || "all",
            listModel: [],
            dataDelivery: [],
            groupedVinsByColor: {},
            areaCode: (this.cookies.get('_amc-a')) ? this.cookies.get('_amc-a') : appDefaultArea,
            isModalVisible: false,
            selectedVin: null,
        }
        this.state = {...this.initState}
    }

    handleResize = () => {
        if (window.innerWidth < 992) {
            this.setState({
                isDesktop: false,
            });
        } else {
            this.setState({
                isDesktop: true,
            });
        }
    }

    onFieldChange = async (value: string) => {
        await this.setState({
            modelSelected: value,
            fetching: true
        });
        
        // Update URL when model changes
        if (value === 'all') {
            this.props.navigate('/delivery');
        } else {
            this.props.navigate(`/delivery/${value}`);
        }
        
        await this.fetchVinAllocation();
    }

    fetchAllModelProduct = async () => {
        try {
            const result = await trimitraCatalogServices.getCatalogModel({areaCode: this.state.areaCode});
            this.setState({
                listModel: result.data.data ?? []
            });
        } catch (e) {
            this.setState({
                listModel: []
            });
        }
    }

    groupVinsByColor = (vins: VinAllocation[]) => {
        const grouped = vins.reduce((acc: { [key: string]: VinAllocation[] }, vin) => {
            const colorKey = `${vin.color_code}-${vin.color_name}`;
            if (!acc[colorKey]) {
                acc[colorKey] = [];
            }
            acc[colorKey].push(vin);
            return acc;
        }, {});
        
        return grouped;
    }

    fetchVinAllocation = async () => {
        this.setState({ fetching: true });
        try {
            const result = await trimitraCatalogServices.getVinAllocation({
                model: this.state.modelSelected !== 'all' ? this.state.modelSelected : undefined
            });
            const groupedVins = this.groupVinsByColor(result.data.data);
            this.setState({
                dataDelivery: result.data.data,
                groupedVinsByColor: groupedVins,
                fetching: false
            });
        } catch (e) {
            this.setState({
                dataDelivery: [],
                groupedVinsByColor: {},
                fetching: false
            });
        }
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 10);

        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();

        this.fetchAllModelProduct();
        this.fetchVinAllocation();
    }

    onAreaChange = async (data: any) => {
        this.cookies.set('_amc-a', data.city_group);
        await this.promisedSetState({
            areaCode: data.city_group,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    handleBookingClick = (vin: VinAllocation) => {
        this.setState({
            isModalVisible: true,
            selectedVin: vin,
        });
    };

    handleModalCancel = () => {
        this.setState({
            isModalVisible: false,
            selectedVin: null,
        });
    };

    handleModalSubmit = (values: any) => {
        console.log('Form submitted:', {
            ...values,
            vin: this.state.selectedVin,
        });
        this.setState({
            isModalVisible: false,
            selectedVin: null,
        });
    };

    renderVinList() {
        if (Object.entries(this.state.groupedVinsByColor).length === 0) {
            return <Empty description="Tidak ada data VIN tersedia"/>;
        }

        const firstVin = Object.values(this.state.groupedVinsByColor)[0][0];
        const modelName = firstVin?.model_name || '';

        // Organize data into columns for masonry layout
        const columns: ColorGroup[][] = [[], [], []];
        Object.entries(this.state.groupedVinsByColor).forEach(([colorKey, vins], index) => {
            columns[index % 3].push({ colorKey, vins });
        });

        return (
            <>
                <div style={{ 
                    marginBottom: '24px',
                    padding: '16px',
                    background: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                }}>
                    <Title level={3} style={{ margin: 0 }}>{modelName}</Title>
                </div>

                <Row gutter={16}>
                    {columns.map((column, columnIndex) => (
                        <Col key={`column-${columnIndex}`} xs={24} sm={24} md={8} lg={8}>
                            <Space direction="vertical" style={{ width: '100%', gap: '16px' }}>
                                {column.map(({ colorKey, vins }: ColorGroup) => {
                                    const colorName = colorKey.split('-')[1];
                                    return (
                                        <Card 
                                            key={`card-${colorKey}`}
                                            className="vin-card"
                                            title={
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span>{colorName.replace(/\b\w/g, char => char.toUpperCase())}</span>
                                                </div>
                                            }
                                            extra={<Tag color="grey">{vins.length} unit</Tag>}
                                            style={{ width: '100%' }}
                                        >
                                            {vins.map((vin: VinAllocation) => (
                                                <div key={vin.vin_number} style={{ 
                                                    padding: '8px 0',
                                                    borderBottom: vins.indexOf(vin) < vins.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}>
                                                    <Text strong>{vin.vin_number}</Text>
                                                    <Button 
                                                        type="primary" 
                                                        size="small"
                                                        onClick={() => this.handleBookingClick(vin)}
                                                        style={{
                                                            fontSize: '11px',
                                                            padding: '0 8px',
                                                            height: '22px'
                                                        }}
                                                    >
                                                        Booking
                                                    </Button>
                                                </div>
                                            ))}
                                        </Card>
                                    );
                                })}
                            </Space>
                        </Col>
                    ))}
                </Row>

                <FormDelivery
                    visible={this.state.isModalVisible}
                    onCancel={this.handleModalCancel}
                    onSubmit={this.handleModalSubmit}
                    vinData={this.state.selectedVin}
                    onSuccess={this.fetchVinAllocation}
                />
            </>
        );
    }

    render() {
        return (
            <React.Fragment>
                <PageHeader black={true} onAreaChangeProps={this.onAreaChange} areaCode={this.state.areaCode} isDesktop={this.state.isDesktop}/>

                <Row className={`pt-100`}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Breadcrumb className={`pl-20`}>
                            <Breadcrumb.Item>Amarta {appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>VIN Allocation</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row className={`mt-20`} style={{backgroundColor: "#f8f8f8"}}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Row>
                            <Col className={`p-20`} span={24}>
                                <Title level={2}>VIN Allocation {appCompanyName}</Title>
                                <Text>Pilih model kendaraan untuk melihat ketersediaan VIN</Text>
                                <div style={{ marginTop: '20px' }}>
                                    <Select
                                        style={{ width: 200 }}
                                        onChange={this.onFieldChange}
                                        value={this.state.modelSelected}
                                    >
                                        <Select.Option value="all">Semua Model</Select.Option>
                                        {this.state.listModel.map((item: any, i: number) =>
                                            <Select.Option key={i} value={item.model_name}>{item.model_name}</Select.Option>
                                        )}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <div style={this.state.fetching ? {textAlign: "center", padding: "50px 0"} : {display: 'none'}}>
                    <Spin size={'large'} tip="Loading..."/>
                </div>

                <div style={!this.state.fetching ? {} : {display: 'none'}}>
                    <Row className={`p-20`}>
                        <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                            {this.renderVinList()}
                        </Col>
                    </Row>
                </div>

                <div style={{minHeight: 200}}/>
                <FooterSection/>
            </React.Fragment>
        );
    }
}

export default withRouter(DeliveryWrapper);
